import vanScenic from "./index.vue";

/* istanbul ignore next */
vanScenic.install = function(Vue) {
  Vue.component(vanScenic.name, vanScenic);
};

export default vanScenic;
